module.exports = __webpack_public_path__ + "media/images/icon__smallInfoBox@2x-4066ee7e799eca7dfcc2dece280304e9.png";